import { get, includes } from "lodash";
import { useMemo } from "react";

import useStore from "@/state";

export function useFeatureFlag(flag: string) {
  const { session } = useStore();

  const contains = useMemo(() => {
    const featureFlags = get(session, "feature_flags");

    return includes(featureFlags, flag);
  }, [session, flag]);

  return contains;
}
